<div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
  <div class="flex justify-between gap-2">
    <app-task-data-target (click)="navigateToMemberProfile()">
      <mat-icon icon>account_circle</mat-icon>
      <span text>{{ task.data.memberName }}</span>
    </app-task-data-target>
    <p class="font-normal text-neutral-300">{{ formatDate(task.createdAt, true) }}</p>
  </div>
  @if (task.data.notes) {
    <tasks-multiline-text
      class="text-neutral-500"
      [text]="task.data.notes"
    />
  }
</div>

@if (task.status !== taskStatus.Resolved) {
  <form
    class="relative flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm"
    [formGroup]="form"
    (ngSubmit)="submit()"
  >
    <div class="mb-4 flex items-center justify-between">
      <h4>{{ "prescription.label.relatedSpecialist" | translate }}</h4>
      @if (errorMessage()) {
        <span class="text-sm text-error-500">{{ errorMessage() }}</span>
      }
    </div>
    <div class="mb-4 flex w-full flex-col gap-2">
      @if (relatedSpecialistDraft(); as draft) {
        <prescriptions-prescription-draft-list-item
          [draft]="draft"
          [memberId]="task.data.memberId"
        />
      } @else {
        <div
          class="flex cursor-pointer items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-neutral-300 p-6 text-neutral-300 hover:border-neutral-400 hover:bg-neutral-100 hover:text-neutral-400"
          (click)="openSpecialistModal()"
        >
          <span class="my-0.5">{{ "prescription.action.addRelatedSpecialist" | translate }}</span>
          <mat-icon>add</mat-icon>
        </div>
      }
    </div>

    <mat-form-field class="w-full">
      <mat-label>{{ "prescription.label.guaranteeDescription" | translate }}</mat-label>
      <textarea
        matInput
        formControlName="description"
      ></textarea>
    </mat-form-field>

    <div class="flex justify-between">
      <mat-checkbox formControlName="sendGuaranteeNotification">
        {{ "prescription.label.notifyOnAssignment" | translate }}
      </mat-checkbox>
      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="loading() || !relatedSpecialistDraft() || form.invalid"
      >
        {{ "prescription.action.createGuaranteeApplication" | translate }}
      </button>
    </div>

    @if (loading()) {
      <div class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/80">
        <shared-loader />
      </div>
    }
  </form>
}

@if (memberPackage()) {
  <div class="flex flex-col gap-4 rounded-lg bg-neutral-0 p-4 shadow-sm">
    <h4>{{ memberPackage().name }}</h4>
    @if (memberPackage().vendorPackageName || memberPackage().internalDescription) {
      <members-package-description
        [vendorPackageName]="memberPackage()?.vendorPackageName"
        [internalDescription]="memberPackage()?.internalDescription"
      />
    }
  </div>
}
